module.exports = require('./DepBankLocationActivitiesFilingView');
